module.exports = require('./DepBankLocationActivitiesFilingView');
